import { Component } from '@angular/core';

@Component({
    selector: 'db-ssl-certificate-modal',
    templateUrl: './ssl-certificate-modal.component.html',
    styleUrl: './ssl-certificate-modal.component.scss',
    standalone: false
})
export class SslCertificateModalComponent {

}
